import React from 'react';
import BusinessOverview from '../command-center/BusinessOverview';
import TaskList from '../TaskList';
import { Wrench } from 'lucide-react';
import WorkspaceHeader from './WorkspaceHeader';

interface CommandCenterWorkspaceProps {
  activeArea: string;
}

export default function CommandCenterWorkspace({ activeArea }: CommandCenterWorkspaceProps) {
  if (activeArea === 'tasks') {
    return (
      <>
        <WorkspaceHeader
          title="Command Center Tasks"
          icon={Wrench}
          description="View and manage all tasks"
        />
        <div className="bg-white rounded-lg shadow p-6">
          <TaskList />
        </div>
      </>
    );
  }
  
  // Default to overview
  return <BusinessOverview />;
}